import { gVerbosePODebug } from "../constants";

export function OutputSCName(m1, dbObj) {
  if (gVerbosePODebug) {
    var fDef = dbObj.GetFieldDefByID("Name");
    var value = dbObj.GetFieldValue(fDef);
    console.log(m1, value);
  }
}
